type PayloadWithDraftContributors = {
  draftContributorUserIds?: ReadonlyArray<unknown>;
};

/**
 * Collaborative drafts add contributor identities automatically. Sponsored
 * Help must never send that hidden context, even while viewer identity is
 * still loading. User-selected context remains intact so the server can reject
 * non-text Help sends rather than silently discarding the user's intent.
 */
export function stripAutomaticFreeHelpDraftContext<
  Payload extends PayloadWithDraftContributors,
>(payload: Payload): Payload {
  if (!payload.draftContributorUserIds) return payload;
  const sanitized = { ...payload };
  delete sanitized.draftContributorUserIds;
  return sanitized;
}
